import { ReportType } from '@/shared/api/protocol-ts/model/dto_report_pb';

import {
  ORDER_REPORT_TYPE_TO_REQUESTED_REPORT_TYPES,
  REPORT_TYPE_TO_PREVIEW_TEST_ID_SEGMENT,
} from '../config';

type OrderReportTypeToReportTypesMap =
  typeof ORDER_REPORT_TYPE_TO_REQUESTED_REPORT_TYPES;
type KnownReportType =
  OrderReportTypeToReportTypesMap[keyof OrderReportTypeToReportTypesMap][number];

export const getReportPreviewTestIDSegment = (
  reportType: ReportType,
): string | undefined =>
  REPORT_TYPE_TO_PREVIEW_TEST_ID_SEGMENT[reportType as KnownReportType];
